import {CardType, PipettingParameterFieldKey, TaskType} from './dataEnum';

export const commonCardStatePropertiesEnum = {
  TYPE: 'type',
  LOCATION: 'location',
  ROW_TIP_COUNT: 'rowTipCount',
  COLUMN_TIP_COUNT: 'columnTipCount',
  ROW: 'row',
  COLUMN: 'column',
  VOLUME: 'volume',
  NUMBER: 'number',
  DELAY_TIME: 'delayTime',
  TIP_POSITION: 'tipPosition',
  ENABLE_MIXING: 'enableMixing',
  MIXING_CYCLE: 'mixingCycle',
  MIXING_VOLUME: 'mixingVolume',
  MIXING_POSITION_ASPIRATE: 'mixingPositionAspirate',
  MIXING_POSITION_DISPENSE: 'mixingPositionDispense',
  SPEED: 'speed',
  RETRACT_SPEED: 'retractSpeed',
  MIXING_SPEED: 'mixingSpeed',
  PRECISION_DISPENSE: 'precisionDispense',
  DISPENSE_AT_WELL_SIDE: 'dispenseAtWellSide',
  TIP_TOUCH_OFF: 'tipTouchOff',
  TIP_TOUCH_OFF_DELAY: 'tipTouchOffDelay',
  MESSAGE: 'message',
  ID: 'ID',
  IS_SIMPLE_TRANSFER: 'isSimpleTransfer',
  NAME: 'name',
  CARD_ID: 'cardID',
  CARD_NAME: 'cardName',
  CHANGE_TIP: 'changeTip',
  GROUP_ID: 'groupID',
  GROUP_NAME: 'groupName',
  LABWARE_INDEX: 'labwareIndex',
  LABWARE_ID: 'labwareID',
  PROCESSED_TASK_ID: 'processedTaskId',
  STEP: 'step',
  TASKS: 'tasks',
  SUB_TYPE: 'subType',
};

export const commonCardStateUIPropertiesEnum = {
  IS_IGNORED: 'isIgnored',
  IS_SELECTED: 'isSelected',
  IS_INSERT_TASK: 'isInsertTask',
  IS_EXPANDED: 'isExpanded',
  INVALID_TYPES: 'invalidTypes',
  NUMBER: 'number',
  STEP: 'step',
};

export const ASPIRATE_PIPETTING_PARAMETER = [
  PipettingParameterFieldKey.ENABLE_MIXING,
  PipettingParameterFieldKey.MIXING_CYCLE,
  PipettingParameterFieldKey.MIXING_POSITION_ASPIRATE,
  PipettingParameterFieldKey.MIXING_POSITION_DISPENSE,
  PipettingParameterFieldKey.MIXING_SPEED,
  PipettingParameterFieldKey.MIXING_VOLUME,
  PipettingParameterFieldKey.RETRACT_SPEED,
  PipettingParameterFieldKey.SPEED,
  PipettingParameterFieldKey.TIP_POSITION,
  PipettingParameterFieldKey.TIP_POSITION_X_OFFSET,
  PipettingParameterFieldKey.TIP_POSITION_Y_OFFSET,
  PipettingParameterFieldKey.TIP_TOUCH_OFF,
  PipettingParameterFieldKey.TIP_TOUCH_OFF_DELAY,
  PipettingParameterFieldKey.TIP_TOUCH_OFF_HEIGHT,
  PipettingParameterFieldKey.TIP_TOUCH_OFF_DIRECTION_X,
  PipettingParameterFieldKey.TIP_TOUCH_OFF_DIRECTION_Y,
];

export const DISPENSE_PIPETTING_PARAMETER = [
  ...ASPIRATE_PIPETTING_PARAMETER,
  PipettingParameterFieldKey.PRECISION_DISPENSE,
  PipettingParameterFieldKey.DISPENSE_AT_WELL_SIDE,
];

export const MIXING_PIPETTING_PARAMETER = [
  PipettingParameterFieldKey.MIXING_CYCLE,
  PipettingParameterFieldKey.MIXING_POSITION,
  PipettingParameterFieldKey.MIXING_POSITION_ASPIRATE,
  PipettingParameterFieldKey.MIXING_POSITION_DISPENSE,
  PipettingParameterFieldKey.MIXING_SPEED,
  PipettingParameterFieldKey.RETRACT_SPEED,
];

export const PipettingParameterKeysByTaskType = {
  [TaskType.ASPIRATE]: ASPIRATE_PIPETTING_PARAMETER,
  [TaskType.DISPENSE]: DISPENSE_PIPETTING_PARAMETER,
  [TaskType.MIXING]: MIXING_PIPETTING_PARAMETER,
};

export const TASK_DEFAULT_PROPERTIES = [
  commonCardStatePropertiesEnum.ID,
  commonCardStatePropertiesEnum.COLUMN,
  commonCardStatePropertiesEnum.ROW,
  commonCardStatePropertiesEnum.COLUMN_TIP_COUNT,
  commonCardStatePropertiesEnum.ROW_TIP_COUNT,
  commonCardStatePropertiesEnum.TYPE,
  commonCardStatePropertiesEnum.LABWARE_ID,
];

export const SERIAL_DILUTION_RAW_TASK_PROPERTIES = [
  ...TASK_DEFAULT_PROPERTIES,
  commonCardStatePropertiesEnum.NUMBER,
  commonCardStatePropertiesEnum.PROCESSED_TASK_ID,
  commonCardStatePropertiesEnum.STEP,
];

export const NORMALIZATION_STATE_BASE_PROPERTIES = [
  'csvRawData',
  'csvFileName',
  'currentVolume',
  'delimiter',
  'selectedColumnIndex',
  'targetConcentration',
  'wellIncrementPattern',
  'startRow',
  'totalRow',
];

export const NORMALIZATION_STATE_TASK_PROPERTIES = [
  ...NORMALIZATION_STATE_BASE_PROPERTIES,
  'type',
  'diluentWell',
  'sampleLabwareID',
  'diluentLabwareID',
];

export const PROTOCOL_UPDATE_PROPERTIES = [
  'Name',
  'CsvContent',
  'StateContent',
  'IsTessaraProtocol',
  'FolderId',
  'CardObject',
];

export const CARD_DEFAULT_PROPERTIES = [
  commonCardStatePropertiesEnum.ID,
  commonCardStatePropertiesEnum.GROUP_ID,
  commonCardStatePropertiesEnum.TYPE,
  commonCardStatePropertiesEnum.SUB_TYPE,
  commonCardStatePropertiesEnum.NAME,
  commonCardStatePropertiesEnum.TASKS,

  commonCardStateUIPropertiesEnum.IS_IGNORED,
  commonCardStateUIPropertiesEnum.IS_SELECTED,
  commonCardStateUIPropertiesEnum.IS_EXPANDED,
];

export const SERIAL_DILUTION_SDPROPERTY_PROPERTIES = {
  sampleVolume: Number,
  diluentVolume: Number,
  aliquotVolume: Number,
  step: Number,
  reuseTips: Boolean,
  equalDiluentVolume: Boolean,
  stepProperties: Array,
  replicateWell: Number,
};

export const WASTE_BIN_LABWARE_ID = 0;

export const TASKS_NEED_VALID_LABWARE = [TaskType.ASPIRATE, TaskType.DISPENSE, TaskType.MIXING];

export const CopyPipettingValueMode = {
  NONE: 0,
  BOTH: 1,
  TO_ALL_TASKS: 2,
  TO_ALL_CARDS: 3,
  TO_SINGLE_TASK: 4,
  TO_SINGLE_CARD: 5,
};

export const ALLOWED_OPEN_CONTEXT_MENU_TASK_TYPES = [TaskType.ASPIRATE, TaskType.DISPENSE, TaskType.MIXING];

export const UTILITY_CARD_TYPES = [CardType.CONSOLIDATE_TIPS, CardType.CONFIRMATION, CardType.DELAY];
